import Vue from "vue";
import VueRouter from "vue-router";
// 引入登陆组件
import Login from "@/views/login/index";
import ResetPassword from "@/views/login/resetPassword";
import ForgetPassword from "@/views/login/forgetPassword";
import registerMember from "@/views/login/registerMember";

import Layout from "@/views/layout/index";
import Home from "@/views/home/index.vue";
import CardManage from "@/views/card/cardManage.vue";
import CardDetail from "@/views/card/cardDetail.vue";
import CardRecharge from "@/views/card/cardRecharge.vue";
import CardRecord from "@/views/card/cardRecord.vue";

import RechargeResult from "@/views/card/rechargeResult.vue";
import Buy from "@/views/order/buy.vue";
import ShopCart from "@/views/order/shopcart.vue";
import Settle from "@/views/order/settle.vue";
import CardPay from "@/views/order/cardPay.vue";
import PayResult from "@/views/order/payResult.vue";
import OrderCenter from "@/views/order/orderCenter";
import CustomOrder from "@/views/order/customOrder";
import CustomDetail from "@/views/order/customDetail";
import OrderWater from "@/views/order/OrderWater";
import OrderDeatil from "@/views/order/orderDetail";
import OrderMoney from "@/views/order/orderMoney";
import KeepOrderWater from "@/views/order/keepOrderWater";

import MemberCenter from "@/views/member/memberCenter";
import MemberList from "@/views/member/memberList";
import Membersearch from "@/views/member/membersearch";
import MemberDetail from "@/views/member/menberDetail";

import CouponList from "@/views/coupon/couponList";
import CouponDetail from "@/views/coupon/couponDetail";
import CouponAfterSale from "@/views/coupon/couponAfterSale";
import ActivateCoupon from "@/views/coupon/activateCoupon";
import CouponRefund from "@/views/coupon/couponRefund";
import BatchActivate from "@/views/coupon/batchActivate";

import Rank from "@/views/rank/rank"
import Attract from "@/views/attract/index"

// import store from '../store'

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      title: "山国工夫茶门店管理",
      requireAuth: false
    }
  },
  {
    path: "/forgetPassword",
    component: ForgetPassword,
    name: "ForgetPassword",
    meta: {
      title: "忘记密码",
      requireAuth: false
    }
  },
  {
    path: "/resetPassword",
    component: ResetPassword,
    name: "ResetPassword",
    meta: {
      title: "重置密码",
      requireAuth: false
    }
  },
  {
    path: "/registerMember",
    component: registerMember,
    name: "registerMember",
    meta: {
      title: "注册山国会员",
      requireAuth: true
    }
  },

  {
    path: "/",
    name: "LayoutIndex",
    component: Layout,
    // 嵌套路由： children中约定的规则如果匹配成功，
    //           就会把相应的组件显示在Layout中的view-router下
    children: [
      // path为空字符串，表示默认路由组件
      {
        path: "",
        component: Home,
        name: "Home",
        meta: {
          title: "山国工夫茶门店管理",
          requireAuth: true
        }
      },
      {
        path: "/cardManage",
        component: CardManage,
        name: "CardManage",
        meta: {
          title: "储值卡管理",
          requireAuth: true
        }
      },
      {
        path: "/cardDetail",
        component: CardDetail,
        name: "CardDetail",
        meta: {
          title: "储值卡详情",
          requireAuth: true
        }
      },
      {
        path: "/cardRecharge",
        component: CardRecharge,
        name: "CardRecharge",
        meta: {
          title: "储值卡充值",
          requireAuth: true
        }
      },
      {
        path: "/cardRecord",
        component: CardRecord,
        name: "CardRecord",
        meta: {
          title: "储值卡消费记录",
          requireAuth: true
        }
      },
      {
        path: "/rechargeResult",
        component: RechargeResult,
        name: "RechargeResult",
        meta: {
          title: "充值结果",
          requireAuth: true
        }
      },
      {
        path: "/buy",
        component: Buy,
        name: "Buy",
        meta: {
          title: "下单",
          requireAuth: true
        }
      },
      {
        path: "/shopcart",
        component: ShopCart,
        name: "ShopCart",
        meta: {
          title: "购物车",
          requireAuth: true
        }
      },
      {
        path: "/settle",
        component: Settle,
        name: "Settle",
        meta: {
          title: "结算页面",
          requireAuth: true
        }
      },
      {
        path: "/cardPay",
        component: CardPay,
        name: "CardPay",
        meta: {
          title: "储值卡支付页面",
          requireAuth: true
        }
      },
      {
        path: "/payResult",
        component: PayResult,
        name: "PayResult",
        meta: {
          title: "订单结果页面",
          requireAuth: true
        }
      },
      {
        path: "/orderCenter",
        component: OrderCenter,
        name: "OrderCenter",
        meta: {
          title: "订单中心",
          requireAuth: true
        }
      },
      {
        path: "/customOrder",
        component: CustomOrder,
        name: "CustomOrder",
        meta: {
          title: "定制订单",
          requireAuth: true
        }
      },
      {
        path: "/customDetail",
        component: CustomDetail,
        name: "CustomDetail",
        meta: {
          title: "定制订单详情",
          requireAuth: true
        }
      },
      {
        path: "/memberCenter",
        component: MemberCenter,
        name: "MemberCenter",
        meta: {
          title: "会员管理中心",
          requireAuth: true
        }
      },
      {
        path: "/memberList",
        component: MemberList,
        name: "MemberList",
        meta: {
          title: "会员数据",
          requireAuth: true
        }
      },
      {
        name: "MemberSearch",
        path: "/memberSearch ",
        meta: {
          title: "搜索会员",
          requireAuth: true
        },
        component: Membersearch
      },
      {
        name: "MemberDetail",
        path: "/MemberDetail",
        meta: {
          title: "会员详情",
          requireAuth: true
        },
        component: MemberDetail
      },
      {
        name: "CouponList",
        path: "/couponList",
        meta: {
          title: "我的提货卡",
          requireAuth: true
        },
        component: CouponList
      },
      {
        name: "CouponDetail",
        path: "/couponDetail",
        meta: {
          title: "卡券详情",
          requireAuth: true
        },
        component: CouponDetail
      },
      {
        name: "CouponAfterSale",
        path: "/couponAfterSale",
        meta: {
          title: "售后详情",
          requireAuth: true
        },
        component: CouponAfterSale
      },
      {
        name: "ActivateCoupon",
        path: "/activateCoupon",
        meta: {
          title: "激活卡券",
          requireAuth: true
        },
        component: ActivateCoupon
      },
      {
        name: "CouponRefund",
        path: "/couponRefund",
        meta: {
          title: "申请卡片状态",
          requireAuth: true
        },
        component: CouponRefund
      },
      {
        path: "/batchActivate",
        component: BatchActivate,
        name: "BatchActivate",
        meta: {
          title: "批量操作",
          requireAuth: true
        }
      }
    ]
  },
  {
    name: "OrderWater",
    path: "/orderWater",
    component: OrderWater,
    // 嵌套路由： children中约定的规则如果匹配成功，
    //           就会把相应的组件显示在Layout中的view-router下
    children: [
      {
        path: "",
        component: KeepOrderWater,
        name: "keepOrderWater",
        meta: {
          title: "订单流水",
          requireAuth: true
        }
      },
      {
        name: "OrderDeatil",
        path: "/orderDeatil",
        meta: {
          title: "消费详情",
          requireAuth: true
        },
        component: OrderDeatil
      },
      {
        name: "OrderMoney",
        path: "/orderMoney",
        meta: {
          title: "充值详情",
          requireAuth: true
        },
        component: OrderMoney
      }
    ]
  },
  {
    path:"/rank",
    component: Rank,
    name:'Rank',
    meta: {
      title: "销售排行",
      requireAuth: false
    }
  },
  {
    path:"/attract",
    component: Attract,
    name:'Attract',
    meta: {
      title: "招商加盟",
      requireAuth: false
    }
  }
];

const router = new VueRouter({
  routes
});

// 全局路由构造函数，判断是否登录和要跳转到页面
router.beforeEach((to, from, next) => {
  if (to.matched.some(m => m.meta.requireAuth)) {
    // 需要登录
    let s = sessionStorage.getItem("shopInfo");
    let shopInfo = s ? JSON.parse(s) : "";
    if (shopInfo != "" && shopInfo.shopCode != null) {
      document.title = to.meta.title;
      next();
    } else if (to.path !== "/login") {
      next({ path: "/login" });
    } else {
      document.title = to.meta.title;
      next();
    }
  } else {
    // 不需要登录
    document.title = to.meta.title;
    next();
  }
});
export default router;
